import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService, ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { BaseHttpService, PopupService } from '@lbmx/root-services';
import { SearchContainerLoaderService } from '@lbmx/search-container';
import { HttpMethod, Request } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { debug } from 'console';
import { ConfirmationService } from 'primeng-lts';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Component({
  selector: 'app-product-exclusion',
  templateUrl: './product-exclusion.component.html',
  styleUrls: ['./product-exclusion.component.scss'],
  providers: [SearchContainerLoaderService, ConfirmationService],
})
export class ProductExclusionComponent {
  constructor(
    private translocoService: TranslocoService,
    private confirmationService: ConfirmationService,
    private toast: ToastrNotificationService,
    private spinner: SpinnerService,
    private configPrv: ConfigProvider,
    private http: BaseHttpService,
    private searchContainerLoaderService: SearchContainerLoaderService,
  ) {
    http.baseUrl = this.baseUrl;
  }

  public showExcludeOptionsDialog = false;
  public selections: any[];
  public searchContainerName = 'productSearch';
  public showGenerateFileDialog = false;
  public showEditDialog = false;
  public exclusionOption = 0;
  public i18nSearchField = 'ACTIONS.SEARCH_PRODUCT';
  public params: { [key: string]: any } = {};
  public baseUrl = `${this.configPrv.AppSetting?.uriAnalytics?.queryEndpoint}` + '/Exclusion/product';
  public excludeUrl = `${this.baseUrl}` + '/exclude-options/form';
  public editUrl = this.baseUrl + '/edit';

  public toolbarActionsDispatcher = {
    add: (selection: any[]) => {
      this.exclusionOption = 0;
      this.showExcludeOptionsDialog = true;
    },

    edit: (selection: any[]) => {
      if (selection.length === 1){
      this.selections = selection;
      this.exclusionOption = 1;
      this.showExcludeOptionsDialog = true;
      }
    },

    delete: (selection: any[]) => {
      this.selections = selection;

      this.confirmationService.confirm({
        message: this.translocoService.translate(
          'ANALYTICS_EXCLUSION.DELETE_PRODUCT_MESSAGE'
        ),
        header: this.translocoService.translate(
          'ANALYTICS_EXCLUSION.DELETE_PRODUCT_HEADER'
        ),
        acceptLabel: this.translocoService.translate('ACTIONS.YES'),
        rejectLabel: this.translocoService.translate('ACTIONS.NO'),
        accept: () => {
          this.spinner.on();
          const selectedKeys = [...selection].map(
            ({ productExclusionKey, ..._ }) => productExclusionKey
          );

          this.http
            .fetch({
              endpoint: '/delete',
              httpMethod: 'POST',
              body: {
                ProductExclusionKeys: selectedKeys,
              },
            })
            .pipe(
              tap(() => {
                this.toast.successNotify(
                  this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
                );

                this.searchContainerLoaderService.refreshSearch();
              }),
              catchError(() =>
                of(
                  this.toast.errorNotify(
                    this.translocoService.translate('MESSAGES.GENERIC_ERROR')
                  )
                )
              ),
              finalize(() => this.spinner.off())
            )
            .subscribe();
        },
        reject: () => {
          /* empty */
        },
      });
    },
  };
  public columnActions = {};

  public closeExcludeOptionsDialog() {
    this.showExcludeOptionsDialog = false;
  }

  public updateExcludeOptions() {
    this.searchContainerLoaderService.refreshSearch();
  }

  public closeEditDialog() {
    this.showEditDialog = false;
  }

  public submitEditDialog() {
    this.showEditDialog = false;
    this.searchContainerLoaderService.refreshSearch();
    this.toast.successNotify(
      this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
    );
  }
}
